module.exports = __webpack_public_path__ + "img/tu12.66eb4fea.png";